import { Stack } from '@mui/material';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { TGroupCardRowProps } from '@/console/features/card-layout/components/recent-groups-card/components/group-card-row/group-card-row.types';
import { GroupContent } from '@/console/features/card-layout/components/recent-groups-card/components/group-content/group-content';
import { groupsApi } from '@/shared/redux/api/assets/groups/groups-api';

export const GroupCardRow: React.FC<TGroupCardRowProps> = ({ group }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const prefetchGroup = groupsApi.usePrefetch('ReadResourceGroupById');

  const handleRowClick = () => {
    navigate({
      pathname: `/groups/${group.groupId}`,
      search: searchParams.toString(),
    });
  };

  const handleMouseEnter = () => {
    prefetchGroup({ groupId: group.groupId });
  };

  return (
    <Stack
      onMouseEnter={handleMouseEnter}
      onClick={handleRowClick}
      direction="row"
      justifyContent="space-between"
      width="100%"
    >
      <GroupContent group={group} />
    </Stack>
  );
};
